module.exports = __webpack_public_path__ + "media/images/flags/BS-f69c7a324cb051c1dde3ba0c3e8cdc81.svg";